import gql from '@/services/gql'
import httpClient from '@/services/httpClient'
import { GRAPHQL_PATH } from '@/services/config'
import { buildQuery } from '@/graphql/builders/query.builder'
import { buildMutation } from '@/graphql/builders/mutation.builder'

export function normalizeVariables(variables) {
  return variables ?? {}
}

export async function requestGraphql({ query, variables = {}, path = GRAPHQL_PATH } = {}) {
  if (!query) throw new Error('requestGraphql: query is required')
  return gql.request({ query, variables: normalizeVariables(variables), path })
}

export async function requestBuiltQuery({ fragment, field, variables = {}, typeMap = {}, path = GRAPHQL_PATH } = {}) {
  const vars = normalizeVariables(variables)
  const { query } = buildQuery({ fragment, field, variables: vars, typeMap })
  return requestGraphql({ query, variables: vars, path })
}

export async function requestBuiltMutation({ fragment, mutationName, field, variables = {}, typeMap = {}, path = GRAPHQL_PATH } = {}) {
  const vars = normalizeVariables(variables)
  const { query } = buildMutation({ fragment, mutationName, field, variables: vars, typeMap })
  return requestGraphql({ query, variables: vars, path })
}

export async function requestGraphqlUpload({ query, variables = {}, filesMap = {}, path = GRAPHQL_PATH } = {}) {
  if (!query) throw new Error('requestGraphqlUpload: query is required')

  const formData = new FormData()
  const operationsVariables = { ...normalizeVariables(variables) }
  const map = {}

  Object.entries(filesMap).forEach(([key, config], index) => {
    const file = config?.file ?? config
    const variablePath = config?.variablePath || `variables.${key}`

    operationsVariables[key] = null
    map[String(index)] = [variablePath]
    formData.append(String(index), file, file?.name)
  })

  formData.append('operations', JSON.stringify({ query, variables: operationsVariables }))
  formData.append('map', JSON.stringify(map))

  const { data } = await httpClient.post(path, formData, {
    headers: { Accept: 'application/json', 'Content-Type': undefined },
  })

  if (data?.errors?.length) {
    const err = new Error(data.errors[0]?.message || 'GraphQL error')
    err.graphQLErrors = data.errors
    throw err
  }

  return data?.data
}

export default {
  normalizeVariables,
  requestGraphql,
  requestBuiltQuery,
  requestBuiltMutation,
  requestGraphqlUpload,
}
